import React, { useEffect, useState } from "react";
import {
  Box,
  Grid,
  LinearProgress,
  Typography,
  makeStyles,
} from "@material-ui/core";
import DataService from "../../../../../Service";
import {
  TableContainer,
  Table,
  TableBody,
  TableHead,
  TableRow,
  TableCell,
  TablePagination,
} from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  wrapper: {
    "& .MuiLinearProgress-colorPrimary": {
      backgroundColor: "#707070",
    },
    "& .MuiLinearProgress-barColorPrimary": {
      backgroundColor: "#981B1E",
    },
  },
  customTableContainer: {
    overflowX: "initial",
  },
  container: {
    maxHeight: 440,
  },
  root: {
    backgroundColor: "#F7F7F7",
    "& .MuiListItem-root.Mui-selected": {
      backgroundColor: "#981B1E1A",
    },
  },
  large: {
    width: theme.spacing(13),
    height: theme.spacing(13),
  },
  demo1: {
    overflowY: "auto",
    height: "410px",
    zIndex: 1301,
  },
  demo2: {
    position: "sticky",
    top: 0,
    zIndex: 1,
  },
  //   demo1: {
  //     backgroundColor: theme.palette.background.paper,
  //     // width: "80.6%",
  //     marginTop: "-15px",
  //     zIndex: 1301,
  //     position: "static",
  //     marginBottom:"20px"
  //     // padding: "5%",
  //   },
  //   demo2: {
  //     position: "relative",
  // overflow:"scroll",
  //     // paddingTop: "100px",
  //     padding: "20px",
  //     // marginTop: "50px",
  //     zIndex: 1,
  //   },
}));

const CoachingAgreementForm = (props) => {
  const { id } = props;
  const classes = useStyles();
  const [CAFList, setCAFList] = useState([]);
  const [CAFDate, setCAFDate] = useState([]);
  useEffect(() => {
    fetchCAF();
  }, []);
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(5);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };
  const columns = [
    {
      label: "Organizational metric",
      id: "organisation_metric",
    },
    {
      label: "Objective no",
      id: "objective",
    },
    {
      label: "Description of objective",
      id: "description_of_objective",
    },
    {
      label: "What will you do to get there?",
      id: "what_will_you_do_to_get_there",
    },
    {
      label: "Business impact",
      id: "business_impact",
    },
    {
      label: "Measurement metrics",
      id: "measurement_metrics",
    },
    {
      label: "Percentage completion",
      id: "percentage_completion",
    },
    {
      label: "Evidence/Comments",
      id: "evidence_comments",
    },
  ];

  const fetchCAF = () => {
    DataService.getData({ assignment_id: id }, "fetch_coaching_agreement")
      .then((res) => {
        if (res?.success) {
          setCAFDate(res?.assignment_caf_summary);
          setCAFList(res?.assignment_caf_summary.collate_objective);
        }
      })
      .catch((error) => console.log(error));
  };

  return (
    <Box classes={{ root: classes.wrapper }}>
      <Grid container direction="row">
        <Grid item xs={12}>
          <Typography variant="subtitle1" style={{ color: "#232323" }}>
            <Box textAlign="left" mt={2} fontWeight="fontWeightBold">
              Initial coaching agreement received date
            </Box>
          </Typography>
          <Typography variant="h2" style={{ color: "#707070CC" }}>
            <Box textAlign="left" mt={1}>
              {CAFDate?.caf_received_date}
            </Box>
          </Typography>
        </Grid>

        <Grid item xs={12}>
          <Typography variant="subtitle1" style={{ color: "#232323" }}>
            <Box textAlign="left" mt={2} fontWeight="fontWeightBold">
              CAF last updated date
            </Box>
          </Typography>
          <Typography variant="h2" style={{ color: "#707070CC" }}>
            <Box textAlign="left" mt={1} mb={3}>
              {/* 29/07/1974 - Objective 1 (updated) */}
              {CAFDate?.last_updated_at}
            </Box>
          </Typography>
        </Grid>
        <TableContainer className={classes.container}>
          <Table stickyHeader aria-label="sticky table">
            <TableHead>
              <TableRow>
                {columns.map((column) => (
                  <TableCell key={column.id}>{column.label}</TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {CAFList.length > 0 &&
                CAFList.slice(
                  page * rowsPerPage,
                  page * rowsPerPage + rowsPerPage
                ).map((item, index) => {
                  return (
                    <React.Fragment>
                      {CAFList[index].objectives.length > 0 &&
                        CAFList[index].objectives.map((row) => {
                          return (
                            <TableRow
                              hover
                              role="checkbox"
                              tabIndex={-1}
                              key={row.code}
                            >
                              {columns.map((column) => {
                                const value = row[column.id];
                                const val = item[column.id];
                                return (
                                  <React.Fragment>
                                    {column.id === "organisation_metric" ? (
                                      <TableCell
                                        style={{ verticalAlign: "top" }}
                                        key={column.id}
                                      >
                                        {val}
                                      </TableCell>
                                    ) : (
                                      <TableCell
                                        style={{ verticalAlign: "top" }}
                                        key={column.id}
                                      >
                                        {value}
                                      </TableCell>
                                    )}
                                  </React.Fragment>
                                );
                              })}
                            </TableRow>
                          );
                        })}
                    </React.Fragment>
                  );
                })}
            </TableBody>
          </Table>
        </TableContainer>
      </Grid>
    </Box>
  );
};

export default CoachingAgreementForm;
